module.exports = __webpack_public_path__ + "img/CopyIcon.5948b829.svg";